import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Where a page starts when you arrive at it.
 *
 * The router does not touch the scroll position, so following a link from
 * halfway down the landing page opened /features halfway down as well — a
 * page that appears to begin in the middle of its own third section. A new
 * navigation starts at the top; a hash goes to its section; going back
 * leaves the browser's own restoration alone, because that is the one case
 * where the old position is the right one.
 */
export function ScrollBehaviour() {
  const { pathname, hash, key } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;

    if (hash) {
      // The element may be a frame away if the route has just mounted.
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
      const id = window.requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView();
      });
      return () => window.cancelAnimationFrame(id);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, key, navigationType]);

  return null;
}
